import { SidenavService } from 'src/app/services/sidenav.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { CompanyService } from 'src/app/services/company.service';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'app-company-detail',
  templateUrl: './company-detail.component.html',
  styleUrls: ['./company-detail.component.scss']
})
export class CompanyDetailComponent implements OnInit {

  showAdminCoadmin: boolean = true;
  showErt: boolean = false;
  showActiveEmp: boolean = false;
  showInactiveEmp: boolean = false;
  myCompanyData: any = [];
  buildingName: string;
  employeeList: any = [];
  parkTenantId: string;
  parkId: string = localStorage.getItem('parkId');
  isLoaded: boolean = false;
  companyEdit: any;
  maxConferenceRoom: any;
  totalMeetingRoomCount: any;
  isCompanyActive: boolean = true;
  isTenantExpired: any;

  constructor(
    private companyService: CompanyService,
    private sideNavService: SidenavService,
    private activateRoute: ActivatedRoute,
    private appStateSrv: AppStateProvider,
    private rolebasedactionService: RolebasedactionService,
  ) {
    this.parkTenantId = this.activateRoute.snapshot.params.id;
    this.getMyCompanyDetails();
    localStorage.setItem('tenantAdminId', this.parkTenantId);
    const customUrl = `/company/details/${this.parkTenantId}`
    const route = this.sideNavService.routingChunks({ name: 'Company', customUrl: customUrl });
    this.appStateSrv.setSideNavState(route);
  }

  tabs = [
    {
      label: 'Admin & Co-admin',
      id: 0,
      isActive: this.showAdminCoadmin
    },
    {
      label: 'ERT',
      id: 1,
      isActive: this.showErt
    },
    {
      label: 'Active Employees',
      id: 2,
      isActive: this.showActiveEmp
    },
    {
      label: 'Inactive Employees',
      id: 3,
      isActive: this.showInactiveEmp
    },
  ];


  ngOnInit() {
    this.companyEdit = this.rolebasedactionService.checkUserRolePermissionExits('Company:Edit');
  }


  selectedItem(item) {
    console.log(item);
    console.log(this.isLoaded);
    this.showAdminCoadmin = false;
    this.showErt = false;
    this.showActiveEmp = false;
    this.showInactiveEmp = false;
    this.tabs = this.tabs.map(el => {
      if (item.id == el.id)
        el.isActive = true;
      else
        el.isActive = false;
      return el;
    }
    )
    switch (item.id) {
      case 0:
        this.showAdminCoadmin = true;
        break;
      case 1:
        this.showErt = true;
        break;
      case 2:
        this.showActiveEmp = true;
        break;
      case 3:
        this.showInactiveEmp = true;
        break;
    }
  }

  updateEmployeeList(list: any[]) {
    this.employeeList = list;
  }

  getMyCompanyDetails() {
    console.log(this.showErt);
    this.companyService.getMyCompanyDetails(this.parkTenantId, this.parkId).subscribe(
      (response: any) => {
        if (response.isValid && response.data != null) {
          console.log(response.data.employees);
          this.myCompanyData = response.data;
          this.employeeList = this.myCompanyData?.employees;
          this.isLoaded = true;
          this.maxConferenceRoom = this.myCompanyData.maxConferenceRoom ?? 0;
          this.totalMeetingRoomCount = this.myCompanyData.totalMeetingRoomCount ?? 0;
          this.isCompanyActive = this.myCompanyData?.isActive;
          this.isTenantExpired = this.myCompanyData?.isTenantExpired;
          console.log(this.maxConferenceRoom);
          console.log(this.totalMeetingRoomCount);
          localStorage.setItem('totalMeetingRoomCount', this.totalMeetingRoomCount);
          localStorage.setItem('maxConferenceRoom', this.maxConferenceRoom);
          localStorage.setItem('isCompanyActive', this.isCompanyActive.toString());
          localStorage.setItem('isTenantExpired', this.isTenantExpired.toString());
          // this.buildingName = this.myCompanyData.BuildingName.join(',');
          localStorage.setItem('isCompanyActive', this.isCompanyActive.toString());
          localStorage.setItem('isTenantExpired', this.isTenantExpired.toString());
          let emailDomain = []
          response.data.emailDomain.forEach(element => {
            if (element !== null) {

              emailDomain.push('@' + (element).split('@')[1]);
            }
          });
          localStorage.setItem('companyEmailDomain', JSON.stringify(emailDomain))
        } else {
          this.isLoaded = true
        }
      }
    );
  }


}


